module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jBVlPK/tc-custom/9781488051531.jpg?1726617370068",
      "alt": "This image is the cover for the book Marriage Wager"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marriage Wager\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("New York Times")]), _vm._v("–Bestselling Author: A society matchmaker is put to the test . . . “Camp delivers another beautifully written charmer.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _c('br'), _c('br'), _vm._v(" No longer in the first blush of youth and without a marriage portion, Miss Constance Woodley can scarcely imagine why one of the leading lights of London society should take an interest in the likes of her. But under her benefactor’s guiding hand, she’s transformed into a captivating creature who catches the eye of the handsome, charming, and ever-so-slightly notorious Lord Dominic Leighton."), _c('br'), _c('br'), _vm._v(" And before the shocked eyes of the entire ton, the “nobody” and the rakish viscount show that even in the heartless world of the marriage mart, when love is at stake, all bets are off . . ."), _c('br'), _c('br'), _vm._v(" “[A] delightful, Regency-era variation on the Cinderella theme.” —"), _c('i', [_vm._v("Booklist")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Candace Camp\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Candace Camp is a New York Times bestselling author of over sixty novels of contemporary and historical romance. She grew up in Texas in a newspaper family, which explains her love of writing, but she earned a law degree and practiced law before making the decision to write full-time. She has received several writing awards, including the RT Book Reviews Lifetime Achievement Award for Western Romances. Visit her at www.candace-camp.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0